import { MRT_RowData } from "material-react-table";
import { CustomMRTFilter } from "../mrt.types";
import { DisplayApi, filterValueOf } from "./SelectManyFromFilter";

type OneFromManyOptions<T extends MRT_RowData, SelectData> = {
    mrtProps: CustomMRTFilter<T>;
    selectOptions: DisplayApi<SelectData>;
    newValues: SelectData[];
};
export const onChangeManyFromMany = <T extends MRT_RowData, SelectData>(options: OneFromManyOptions<T, SelectData>) => {
    const { newValues, mrtProps, selectOptions } = options;

    if (newValues.length === 0) {
        mrtProps.column.setFilterValue(null);
        return;
    }

    // newValues is already the complete list of currently selected items (from FoodsCheckbox)
    const results = newValues.map((i) => filterValueOf(selectOptions, i));
    mrtProps.column.setFilterValue(results);
};
